import { createStore } from 'redux'
import { ChangeValuesReservations, loadEvents, reservaEvent, reservateSeat, loadCurrentEvent } from './Reducers/ReservationsReducer'
import { Login, Logout } from './Reducers/LoginReducer';
import { updateProfileFields } from './Reducers/ProfileReducer';
const state = { 
    // url:'http://0.0.0.0:8000',
    url:'http://reservas.countryclub.do',
    propertie: {
        descripcion: {
            titulo: '',
            categoria: '',
            habitaciones: '',
            banos: '',
            parqueos: '',
            condicion: '',
            estilo: '',
            tipo_operacion: '',
            metraje_construccion: '',
            metraje_terreno: '',
            permite_construccion: '',
        },
    },
    CurrentSeat:{},
    listEvents:[],
    currentEvent:{},
    login: false,
    currentUser:{
        name:'',
        number:''
    }

}

const reducer = (state, action) => {
    switch (action.type) {
        case 'ChangeValuesReservations':
            return ChangeValuesReservations(state, action)
        case 'loadEvents':
            return loadEvents(state, action)
        case 'reserva':
            return reservaEvent(state,action)
        case 'reservateSeat':
            return reservateSeat(state,action);
        case "Login":
            return Login(state, action);
        case "Logout":
            return Logout(state, action);
        case "updateProfileFields":
            return updateProfileFields(state, action);
        case "loadCurrentEvent":
            return loadCurrentEvent(state, action);
        default:

            break;
    }
    return state
}

const store = createStore(reducer, state);

export default store;


// WEBPACK FOOTER //
// ./src/Store/store.js